import { useQuery } from '@tanstack/react-query';
import { productsManagementQueries } from '@/activityLog/productsManagement/queries/productsManagementQueries.ts';
import { fetchProductManagementErrors } from '@/activityLog/productsManagement/productManagementApi/productsManagementApi.ts';

export const useProductManagementErrors = (requestId: string) => {
  return useQuery({
    queryKey: productsManagementQueries.errors(requestId),
    queryFn: ({ signal }) => fetchProductManagementErrors(requestId, signal),
  });
};
